<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="900px"
  :close-on-click-modal="false">
    <el-form :model="form" ref="form">
      <div class="cost-table">
        <div v-for="(item,index) in form.tableData" :key="index">
          <div>
            <div class="table-title">{{item.title}}</div>
            <div class="table-value">
              <el-form-item
                class="cost-input"
                :prop="'tableData.' + index + '.value'"
                :rules="validateTable()">
                <el-input v-model="item.value" autocomplete="off" style="width: 105px"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitHandle">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
    import costDialogJs from "./costDialog.js"

    export default costDialogJs
</script>

<style lang="scss" scoped>
  @import "costDialog";
</style>



// WEBPACK FOOTER //
// src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/costDialog/costDialog.vue